module.exports = __webpack_public_path__ + "img/pdf_ico.a0bd75d0.png";